/**
 * Enum representing the origin of an activity.
 * Used to determine how an activity was created and what source information should be displayed.
 *
 * @public
 */
export var ActivityOrigin;
(function (ActivityOrigin) {
    /**
     * Activity was created from scratch (new activity).
     * No source information is available or should be displayed.
     */
    ActivityOrigin["ORIGINAL"] = "original";
    /**
     * Activity was cloned within the same workspace.
     * A variant/copy of an existing activity in the current workspace.
     */
    ActivityOrigin["CLONED"] = "cloned";
    /**
     * Activity is a new version of an existing activity in the same workspace.
     * The activity was versioned (e.g., version 2, 3, etc.) from a previous version.
     */
    ActivityOrigin["VERSIONED"] = "versioned";
    /**
     * Activity was cloned from another workspace.
     * The activity originated from a different workspace and was cloned into the current workspace.
     */
    ActivityOrigin["CROSS_WORKSPACE_CLONED"] = "cross_workspace_cloned";
})(ActivityOrigin || (ActivityOrigin = {}));
//# sourceMappingURL=activity_origin.js.map